BoardsSidebarSectionView = require 'views/boards-sidebar/boards-sidebar-section-view'
l = require 'lib/localize'

module.exports = class BoardsSidebarMyBoardsSectionView extends BoardsSidebarSectionView
  initialize: ->
    super
    @listenTo @model.boardList, 'add remove reset change:idOrganization', @debouncedRenderBoards

  getBoards: ->
    (board for board in @model.boardList.models when !board.isOrgBoard() && board.isOpen())

  sectionId: -> 'my-boards'

  sectionName: -> "Personal Boards"

  doesTruncate: -> true

  getHeaderInfo: ->
    {
      title: @getTitle()
      iconClass: 'board'
    }

  getTitle: -> l('board section title.personal boards')



// WEBPACK FOOTER //
// ./app/scripts/views/boards-sidebar/boards-sidebar-my-boards-section-view.coffee